/**
 * How We Work — six operating principles.
 * These are the commitments behind every engagement.
 */

export const howWeWorkHead = {
  eyebrow: 'How we work',
  heading: 'Principles, not pitch decks.',
  description:
    'How we run engagements. What you can expect. What we will not do.',
};

// Bridge into the Process section. Homepage-only: HowWeWork always renders
// with Process directly below it, so "below" is safe.
export const howWeWorkFoot = {
  line: 'Those are the commitments. The process below is the order they happen in.',
};

export const principles = [
  {
    number: '01',
    title: 'Scope before start',
    body: 'Fixed scope, fixed quote. You know the number before we start.',
  },
  {
    number: '02',
    title: 'Training is included',
    body: 'Role-specific training ships with every build. Adoption is engineered in, not added later.',
  },
  {
    number: '03',
    title: 'You own the result',
    body: 'Source, docs, and access transfer on completion. No lock-in, no licence to keep paying.',
  },
  {
    number: '04',
    title: 'Locally hosted by default',
    body: 'Your data stays in your region and jurisdiction. Residency is settled up-front, not after.',
  },
  {
    number: '05',
    title: 'Observability from day one',
    body: 'Every run and every dollar, logged and visible. Fewer steps, lower cost.',
  },
  {
    number: '06',
    title: '48-hour proposals',
    body: 'Send your brief. Fixed pricing and a delivery plan by the next business day.',
  },
];
